<template>
  <div class="w-100">
    <span id="top-section"></span>
    <div class="my-5" v-if="is_load">
      <loader />
    </div>
    <div v-else>
      <div class="m-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <!-- UNPAID -->
        <div class="px-4 py-5" v-if="payment.status == 'UNPAID'">
          <VirtualAccount
            v-if="payment.payment_method == 'VIRTUAL_ACCOUNT' || payment.payment_method == 'BANK_TRANSFER'"
            :data="payment.detail"
            module_page="RESTAURANT"
            :customer_detail="trx_detail.customer_detail" />
          <Qris 
            v-if="payment.payment_method == 'QRIS'"
            :data="payment.detail"
            module_page="RESTAURANT"
            :customer_detail="trx_detail.customer_detail" />
          <div class="my-3 w-100 text-center">
            <p class="body-2-4 mb-2">
              {{$t("hotel.waiting.already-made-a-payment")}}
            </p>
            <state-button size="lg" variant="primary" :click="loadDetailPayment" block>{{$t("hotel.waiting.check-payment-status")}}</state-button>
            <p class="body-2-4 text-danger mb-0 mt-2" v-if="payment_still_not_complete">Your payment is still being checked</p>
          </div>
        </div>

        <!-- SUCCESS -->
        <div class="px-4 pt-5" v-else>
          <div class="text-center mb-4">
            <div class="w-100 text-center mb-2">
              <i class="text-40" 
                :class="payment.status == 'SUCCESS'? 'simple-icon-check text-green' : 'simple-icon-close text-danger'"></i>
            </div>
            <p class="mb-0 body-2-1 text-green" v-if="payment.status == 'SUCCESS'">Payment Success</p>
            <p class="mb-0 body-2-1 text-danger" v-else>{{$capitalize(payment.status)}}</p>
            <p class="mb-4 heading-4-1">{{$formatCurrency(total_bill)}}</p>
            <div class="w-100">
              <img :src="getMerchant().image_url" width="70" class="mx-auto mb-2">
              <p class="mb-0 body-2-1">{{getMerchant().name}}</p>
            </div>
          </div>
          <div class="w-100 border-semi-grey radius-12 p-3 mb-4">
            <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Invoice Number</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0">{{trx_detail.invoice}}</p>
              </div>
            </div>
            <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Payment Method</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0">{{payment.bank_name}}</p>
              </div>
            </div>
            <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Status</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0" :class="payment.status == 'SUCCESS'? 'text-green' : 'text-danger'">{{$capitalize(payment.status)}}</p>
              </div>
            </div>
            <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Date</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0">{{$formatDateTime(payment.created_at)}}</p>
              </div>
            </div>
            <div v-if="Number(payment_surcharge) > 0" class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Payment Surcharge</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0">{{$formatCurrency(payment_surcharge)}}</p>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-6">
                <p class="body-2-2-1 mb-0">Total Paid</p>
              </div>
              <div class="col-6 text-right">
                <p class="body-2-1 mb-0">{{$formatCurrency(total_bill)}}</p>
              </div>
            </div>
          </div>
          <button type="button" class="w-100" :class="{'button-primary':payment.status == 'SUCCESS','button-black':payment.status == 'CANCELLED' || (payment.payment_method == 'CREDIT_CARD' && payment.status == 'UNPAID')}" @click="goToHome">{{$t('hotel.action.back-to-homepage')}}</button>
        </div>

      </template>
    </div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
	import {post,get} from '@/services/index.js';
	import moment from 'moment';
	import cartHeader from '@/components/hotel/cartHeader';
	import {formatCurrency,paymentMethodConverter,formatDate} from '@/utils/index.js';
  import QrisForm from '@/components/ticket/QrisForm';
  import VirtualAccountForm from '@/components/hotel/VirtualAccountForm';
  import VirtualAccountBank from '@/components/hotel/be/VirtualAccountBank';
  import Qris from '@/components/general/payment/Qris'

  export default{
    components: {
      QrisForm,
      VirtualAccountForm,
      VirtualAccountBank,
      Qris
    },
    metaInfo(){
      return {
        title: 'Payment Result',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {},
        detail_trx: {},
        original_data: {},
        trx_detail: {},
        payment: {},
        payment_still_not_complete: false
      }
    },
    computed:{
      payment_status(){
        let display = ''
        if(this.payment.status == 'SUCCESS'){
          display = this.$t('general.payment-success')
        }else if(this.payment.status == 'UNPAID'){
          display = this.$t('general.waiting-for-payment')
        }else if(this.payment.status == 'CANCELLED'){
          display = this.$t('general.payment-failed')
        }else{
          display = this.payment.status
        }
        return display
      },
      payment_surcharge(){
				let data = 0
				if(this.payment.status && this.payment.status != 'PAY_LATER'){
					data = this.payment.detail.payment_surcharge
				}
				return Number(data)
			},
      total_bill(){
				let data = 0 
				if(this.trx_detail.id){
					data = Number(this.trx_detail.total_payment)
				}
				if(this.payment_surcharge > 0){
					data += this.payment_surcharge
				}
				return data 
			},
		},
    mounted() {
      this.loadDetailPayment()
    },
    methods: {
      ...mapGetters([
        'getMerchant',
        'getMetaTitleTemplate'
      ]),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      goToHome(){
        this.$router.push(`/${this.getMerchant().code}`)
      },
      parsingPaymentMethod(pm){
        return paymentMethodConverter(pm)
      },
      loadDetailPayment(){
        return new Promise((success,fail)=>{
          this.is_load = true
          get("CORE_RESTO",`v2/tx-guest-bill-detail/${this.$route.params.tx_payment_id}`,{
            merchant_id: this.getMerchant().id
          },'restaurant_session').then(response=>{
            let res = response.data
            if(res.success){
              let clone_data = this.$deepCopy(res.data)
              this.original_data = clone_data
              this.trx_detail = clone_data
              this.getDetailPayment(clone_data.tx_payment_list)
              let customer_detail = JSON.parse(this.trx_detail.customer_detail)
              this.trx_detail.customer_detail = customer_detail.customer_detail
              this.trx_detail.customer_detail.full_name = customer_detail.customer_detail.name
              // if(this.$isNotEmpty(clone_data.customer_detail.last_name)){
              //   this.trx_detail.customer_detail.full_name += ` ${clone_data.customer_detail.last_name}`
              // }
              
              
              // this.detail_trx = res.data
              // this.detail_trx.customer_detail = JSON.parse(this.detail_trx.customer_detail)
              // this.detail_trx.detail = JSON.parse(this.detail_trx.detail)
              success(res.data)
            }else{
              this.error = res.message
              fail()
            }
            this.is_load = false
          })
        })
      },
      getDetailPayment(payment){
				if(payment.length == 0){
					this.payment.status = 'PAY_LATER'
				}else{
					let clone_data = this.$deepCopy(payment[0].tx_bill_payment)
					this.payment = {
						status: clone_data.status,
						bank_name: clone_data.payment_channel.payment_gateway.pg_company,
						pg_mode: clone_data.payment_channel.payment_gateway.pg_mode,
						payment_method: clone_data.payment_channel.channel,
						pg_response: clone_data.inq_resp_detail,
						created_at: payment[0].created_at,
						detail: payment[0],
						payment_detail_error: clone_data.pay_resp_detail == null ? null : clone_data.pay_resp_detail
					}
				}
			},
      checkStatus(){
        return new Promise((success,fail)=>{
          this.payment_still_not_complete = false
          this.loadDetailPayment()
          .then(res=>{
            let payment_status = res.status
            if(payment_status === 'UNPAID' || payment_status === 'PENDING') this.payment_still_not_complete = true
            else {
              setTimeout(() => {
                this.$smoothScroll('top-section')
              }, 100);
            }
          })
          .finally(()=>success())
        })
      },
    },
  }
</script>
<style scoped>
  
  .snow{
    position: fixed;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
  }

  .size-icon {
    width: 85px;
    height: 85px;
    padding: 7px;
  }

  .size-icon-in {
    width: 80px;
    height: 80px
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
    -ms-overflow-style: none;
  }

  .height-img{
    height: 65px;
  }

  .note{
    margin-top: 0px;
  }

  .h-auto{
  	height: auto!important;
  }

  .discon{
    margin-top: -8px;
  }

</style>


// WEBPACK FOOTER //
// src/pages/restaurant/PaymentResult.vue